export function SummaryIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className="size-[9px] text-pitch-black"
      viewBox="0 0 9 9"
      {...props}
    >
      <path
        d="M8.54 6.34c.253 0 .46-.22.46-.49 0-.271-.205-.491-.46-.491L.52 5.351c-.255 0-.461.22-.461.49s.205.49.459.491l8.021.008zm0-5.228c.253 0 .46-.219.46-.49 0-.27-.205-.49-.46-.49L.52.122c-.255 0-.461.22-.461.49 0 .271.205.491.459.491l8.021.008zM6.277 8.953c.254 0 .46-.219.46-.49 0-.27-.205-.49-.459-.49l-5.76-.009c-.253 0-.46.22-.46.49s.206.49.46.491l5.76.008zm0-5.227c.254 0 .46-.22.46-.49 0-.271-.205-.49-.459-.491l-5.76-.008c-.253 0-.46.219-.46.49 0 .27.206.49.46.49l5.76.009z"
        fill="currentColor"
      />
    </svg>
  );
}
